import { type ReactElement } from "react";
import { Text, CitiboxLogo } from "@citibox-panel/ui";
import { Row } from "./DemoScaffold";

export function LogoDemo(): ReactElement {
  return (
    <>
      <Text variant="body2" color="secondary" gutterBottom>
        Marca Citibox (<code>CitiboxLogo</code>): SVG vectorial, color de marca por
        token <code>primaryDark</code>. Tamaño configurable con <code>size</code>.
      </Text>
      <Row>
        <CitiboxLogo />
        <CitiboxLogo size={40} />
        <CitiboxLogo size={56} />
      </Row>
    </>
  );
}
